// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__LXiO0","rootCenter":"LoadMoreObserver_rootCenter__3a7iW","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1Cm8n"};